import 'css-chunksrc/client/pages/searchPage/searchResults/styles.scss';export default {
  "searchResults": "_searchResults_f8evz_1",
  "section": "_section_f8evz_5",
  "title": "_title_f8evz_9",
  "list": "_list_f8evz_15"
};